<template>
  <component :is="tag" :style="style" class="tq-col" :class="colClass">
    <slot></slot>
  </component>
</template>

<script lang="ts">
import { bem } from "../../../utils/bem";

export default {
  name: 'TqCol',
  inject: {
    TqRow: {
      default: null,
    },
  },
  props: {
    tag: {
      type: String,
      default: 'div',
    },
    flex: {
      type: String,
      default: '',
    },
    order: {
      type: Number,
      required: false
    },
    span: {
      type: [String, Number],
      default: 0,
    },
    offset: [String, Number],
  },
  methods: {
    bindRelation() {

      if (!this.parent || this.parent.children.indexOf(this) !== -1) {
        return;
      }

      const children = [...this.parent.children, this];

      // sortChildren(children, this.parent);
      this.parent.children = children;
    },
  },
  created() {
    this.bindRelation();
  },

  beforeDestroy() {
    if (this.parent) {
      this.parent.children = this.parent.children.filter(
        (item:any) => item !== this
      );
    }
  },
  computed: {
    parent():any {
      return this.TqRow;
    },

    index() {
      this.bindRelation();
      if (this.parent) {
        return this.parent.children.indexOf(this);
      }

      return null;
    },
    style(): any {
      if (!this.parent) {
        return {};
      }

      const { spaces, verticalSpaces } = this.parent;
      let styles = {};
      if (spaces && spaces[this.index]) {
        const { left, right } = spaces[this.index];
        styles = {
          paddingLeft: left ? `${left}px` : null,
          paddingRight: right ? `${right}px` : null,
        };
      }

      const { bottom } = verticalSpaces[this.index] || {};
      let flexCol = {}
      if (this.flex) {
        flexCol = {
          'flex': this.flex
        }
      }
      return Object.assign(styles, {
        marginBottom: bottom ? `${bottom}px` : null,
      }, flexCol);
    },

    colClass() {
      const offsetClass:string = this.offset ? `offset-${this.offset}` : '';
      return bem('tq-col', [`${this.span}`, offsetClass]);
    },
  },
};
</script>
